import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from "../helpers/firebase-config.js";

export function setCirurgia(data, id) {

  return new Promise(function(resolve, reject) {
    let ref = Libfirebase.collection("paciente")
      .doc(id)
      .collection("cirurgia");

    ref
      .add(data)
      .then(snap => {
        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}

export function updateCirurgia(idPaciente, idCirurgia, data) {

  return new Promise(function(resolve, reject) {
    Libfirebase.collection("paciente")
      .doc(idPaciente)
      .collection("cirurgia")
      .doc(idCirurgia)
      .update(data)
      .then(() => resolve(true))
      .catch(erro => reject(erro.code));
  });
}

export function setCadastroCirurgico(data, id) {
  return new Promise(function(resolve, reject) {
    Libfirebase.collection("cadastroCirurgico")
      .doc(id)
      .update({ status: "Aguardando Análise" });

    let ref = Libfirebase.collection("paciente")
      .doc(id)
      .collection("cadastroCirurgico");

    ref
      .add(data)
      .then(snap => {
        // resolve(true)

        if (data.midias.length !== 0) {
          data.midias.forEach(item => {
            ref
              .doc(snap.id)
              .collection("Midias")
              .add({ url: item });
          });
        }

        resolve(true);
      })
      .catch(erro => reject(erro.code));
  });
}

export function getListCirurgia(id, idCirurgia = null) {
  return new Promise(function(resolve, reject) {
    let ref = Libfirebase.collection("paciente")
      .doc(id)
      .collection("cirurgia");

    ref

      .orderBy("DataCriacao")
      .get()
      .then(snap => {
        let listCirurgia = [];

        snap.forEach(async doc => {
          let item = doc.data();

          let data = {
            id: doc.id,
            cirurgia: item,
            profissional: ""
          };

          listCirurgia.push(data);
        });
        resolve(listCirurgia);
      })
      .catch(error => reject(error.code));
  });
}
